import React, { useState, useEffect } from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import {
  CModalTitle,
  CModalHeader,
  CModalBody,
  CModal,
  CModalFooter,
  CCol,
  CRow,
  CForm,
  CButton,
  CFormLabel,
  CFormInput,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilCloudUpload, cilImagePlus } from '@coreui/icons'
import { toast } from 'react-toastify'
import CustomButton from 'src/components/Inputs/CustomButton'
import handleErrors from 'src/helpers/handleErrors'
import SingleCustomAutocomplete from 'src/components/CustomAutocomplete/SingleCustomAutocomplete'
import {
  CustomDate,
  CustomInput,
  InLineCustomCheckbox,
} from 'src/components/Inputs/CustomInputForms'
import CustomAutocomplete from 'src/components/CustomAutocomplete/CustomAutocomplete'
import Swal from 'sweetalert2'
import CustomSelectAutocomplete from 'src/components/CustomAutocomplete/CustomSelectAutocomplete'
import { checkPagePermission } from 'src/helpers/FixedData'
import moment from 'moment'

const AddUpdate = (props) => {
  const [saveIsLoading, setSaveIsLoading] = useState(false)
  const [profiles, setProfiles] = useState([])

  const [departments, setDepartments] = useState([])
  const [schools, setSchools] = useState([])
  const [profileImage, setProfileImage] = useState({})
  const [users, setUsers] = useState([])
  const [attachment1, setAttachment1] = useState({})
  const [attachment2, setAttachment2] = useState({})
  const [grades, setGrades] = useState([])

  const defaultValues = {
    id: -1,
    name: '',
    email: '',

    password: '',
    position_id: '',
    position: '',
    profile_id: '',

    first_name: '',

    last_name: '',

    mobile_number: '',
    landline_number: '',

    date_of_birth: null,
    place_of_birth: '',
    country: '',
    grades: [],

    school: '',

    active: 1,
  }

  const [formData, setFormData] = useState(defaultValues)

  const getProfiles = () => {
    axios(`${process.env.REACT_APP_API_BASE_URL}/masterData/profiles`, {
      responseType: 'json',
    })
      .then(function (response) {
        setProfiles(response.data)
      })
      .catch(function (error) {
        handleErrors(error)
      })
  }

  const getFormData = () => {
    axios(`${process.env.REACT_APP_API_BASE_URL}/masterData/admin_users/${props.id}`, {
      responseType: 'json',
    })
      .then((response) => {
        // getEmployees(response.data.position_id)

        setFormData((prev) => ({
          ...prev,
          id: props.id,
          ...response.data,
          grades: response.data.grades?.split(',') ?? [],
        }))

        if (response.data.profile_image) {
          setProfileImage((prev) => ({
            ...prev,
            id: response.data.id,
            path: `${process.env.REACT_APP_API_BASE_URL_ATTACHMENTS}/images/${response.data.profile_image}`,
          }))
        } else {
          setProfileImage({})
        }
      })
      .catch((error) => {
        handleErrors(error)
      })
  }

  const saveForm = () => {
    setSaveIsLoading(true)

    const submitFormData = new FormData()

    for (var key in formData) {
      if (formData[key] || formData[key] == 0) {
        if (key == 'name') {
        } else {
          if (key == 'grades') {
            submitFormData.append(key, formData[key] ? formData[key].join(',') : null)
          } else {
            submitFormData.append(key, formData[key])
          }
        }
      }
    }

    submitFormData.append('active', formData.active)

    if (profileImage && profileImage.file) {
      submitFormData.append('profile_image', profileImage.file)
    }

    submitFormData.append('name', formData.first_name + ' ' + formData.last_name)

    if (formData.id > 0) {
      submitFormData.append('_method', 'put')
      axios({
        method: 'post',
        url: `${process.env.REACT_APP_API_BASE_URL}/masterData/admin_users/${formData.id}`,
        data: submitFormData,
      })
        .then((response) => {
          toast.success('Updated Successfully')
          setSaveIsLoading(false)
          handleClose(true)
        })
        .catch((error) => {
          setSaveIsLoading(false)
          handleErrors(error)
        })
    } else {
      axios({
        method: 'post',
        url: `${process.env.REACT_APP_API_BASE_URL}/masterData/admin_users`,
        data: submitFormData,
      })
        .then((response) => {
          if (props.signup) {
            toast.success('Signed up Successfully')
          } else {
            toast.success('Inserted Successfully')
          }

          setSaveIsLoading(false)
          handleClose(true)
        })
        .catch((error) => {
          setSaveIsLoading(false)
          handleErrors(error)
        })
    }
  }

  const handleInputChange = (e) => {
    const { id, name, value, checked, type } = e.target
    if (type == 'checkbox') {
      setFormData((prev) => ({
        ...prev,
        [id]: checked ? 1 : 0,
      }))
    } else {
      setFormData((prev) => ({
        ...prev,
        [id]: value,
      }))
    }
  }
  const resetForm = () => {
    setFormData(defaultValues)
    setProfileImage({})
  }

  const customOnChange = (newValue, name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }))
  }

  const handleChangeFile = (e, type) => {
    const randomId = -(Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000)
    e.preventDefault()
    const reader = new FileReader()
    const file = e.target.files[0]

    reader.readAsDataURL(file)
    reader.onloadend = () => {
      if (type == 'profile') setProfileImage({ id: randomId, path: reader.result, file: file })

      if (type == 'attachment1') setAttachment1({ id: randomId, path: reader.result, file: file })

      if (type == 'attachment2') setAttachment2({ id: randomId, path: reader.result, file: file })
    }
  }

  const removeFile = (id, type) => {
    if (id > 0) {
      Swal.fire({
        title: 'Please Confirm Your Action ?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        icon: 'warning',
      }).then((result) => {
        if (result.isConfirmed) {
          axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_BASE_URL}/masterData/admin_users/deleteUserFile`,
            data: { id: id, type: type },
          })
            .then((response) => {
              if (type == 'profile_image') setProfileImage({})

              if (type == 'attachment1') setAttachment1({})

              if (type == 'attachment2') setAttachment2({})

              toast.success(`Success`)
            })
            .catch((error) => {
              toast.error(`Error`)
            })
        }
      })
    } else {
      if (type == 'profile_image') setProfileImage({})

      if (type == 'attachment1') setAttachment1({})

      if (type == 'attachment2') setAttachment2({})
    }
  }

  useEffect(() => {
    if (grades.length == 0) {
      axios(`${process.env.REACT_APP_API_BASE_URL}/masterData/grades`)
        .then(function (response) {
          setGrades(response.data)
        })
        .catch(function (error) {})
    }
    // const schools_stored = sessionStorage.getItem('schools')
    // if (schools_stored) {
    //   setSchools(JSON.parse(schools_stored))
    // }

    const admin_profiles_stored = sessionStorage.getItem('admin_profiles')
    if (admin_profiles_stored) {
      setProfiles(JSON.parse(admin_profiles_stored))
    } else {
      getProfiles()
    }

    if (props.visible) {
      if (props.id > 0) {
        getFormData()
      } else {
        resetForm()
      }
    }
  }, [props.visible])

  const handleClose = (status) => {
    resetForm()
    props.handleClose(status)
  }

  return (
    <>
      <CModal backdrop="static" size="lg" visible={props.visible} onClose={handleClose}>
        <CModalHeader>
          {props.signup ? (
            <CModalTitle>Sign Up</CModalTitle>
          ) : (
            <CModalTitle>{props.id > 0 ? 'Update' : 'Add'} User </CModalTitle>
          )}
        </CModalHeader>
        <CModalBody>
          <CForm className="row g-3">
            <CRow className="g-2 mb-5">
              <CCol md={3}></CCol>
              <CCol md={6} className="input-image">
                {profileImage.id ? (
                  <div style={{ position: 'relative', width: 'fit-content' }}>
                    <img src={profileImage.path} width="200" />
                    <div style={{ position: 'absolute', top: -5, right: -40 }}>
                      <CButton
                        color={'danger'}
                        size="sm"
                        className="m-2"
                        variant="outline"
                        onClick={() => {
                          removeFile(profileImage.id, 'profile_image')
                        }}
                      >
                        x
                      </CButton>
                    </div>
                  </div>
                ) : (
                  <>
                    <CFormLabel
                      htmlFor="profile"
                      style={{
                        width: '80%',
                        padding: 20,
                        borderStyle: 'dashed',
                        cursor: 'pointer',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <p>
                          <b>PROFILE IMAGE</b>
                        </p>
                        <CIcon icon={cilCloudUpload} width={75} />
                        {/* <p>Drag and Drop to upload image</p>
                        <b>OR</b> */}
                        <p>Browse file</p>
                        <CIcon icon={cilImagePlus} className="" width={50} />
                      </div>
                    </CFormLabel>
                    <CFormInput
                      className="mb-3"
                      type="file"
                      name="image"
                      id="profile"
                      onChange={(e) => handleChangeFile(e, 'profile')}
                    />
                  </>
                )}
              </CCol>
              <CCol md={3}></CCol>
            </CRow>

            <CRow className="g-1">
              <CCol md={6}>
                <CustomInput
                  fieldLabel="First Name"
                  id={'first_name'}
                  value={formData.first_name}
                  onChange={handleInputChange}
                />
              </CCol>

              <CCol md={6}>
                <CustomInput
                  fieldLabel="Last Name"
                  id={'last_name'}
                  value={formData.last_name}
                  onChange={handleInputChange}
                />
              </CCol>
            </CRow>
            {/* 
            <CRow className="g-1">
              <CCol md={12}>
                <SingleCustomAutocomplete
                  fieldName="school"
                  label="School"
                  list={schools}
                  value={formData.school}
                  listKey="id"
                  description="name"
                  customOnChange={customOnChange}
                />
              </CCol>
            </CRow> */}

            <CRow className="g-1">
              <CCol md={6}>
                <CustomInput
                  disabled={props.signup}
                  fieldLabel={'Email'}
                  id={'email'}
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </CCol>

              <CCol md={6}>
                <CustomInput
                  type={props.id > 0 ? 'password' : ''}
                  disabled={props.id > 0 || props.signup}
                  fieldLabel="Password"
                  id={'password'}
                  value={formData.password}
                  onChange={handleInputChange}
                />
              </CCol>
            </CRow>

            <>
              <CRow className="g-1">
                <CCol md={6}>
                  <SingleCustomAutocomplete
                    fieldName="position_id"
                    label="Position Type"
                    list={[
                      { id: 1, name: 'Admin' },
                      { id: 2, name: 'Teacher' },
                    ]}
                    value={formData.position_id}
                    listKey="id"
                    description="name"
                    customOnChange={customOnChange}
                  />
                </CCol>
                <CCol md={6}>
                  <SingleCustomAutocomplete
                    fieldName="profile_id"
                    label="Profile"
                    list={profiles}
                    value={formData.profile_id}
                    listKey="id"
                    description="name"
                    customOnChange={customOnChange}
                  />
                </CCol>
              </CRow>

              <CRow className="g-1">
                <CustomAutocomplete
                  fieldName="grades"
                  label="Grades"
                  list={grades}
                  values={formData.grades}
                  listKey="id"
                  description="name"
                  customOnChange={customOnChange}
                />
              </CRow>

              <CRow className="g-1">
                <CCol md={12}>
                  <InLineCustomCheckbox
                    label={'Active'}
                    checked={formData.active == 1}
                    id={'active'}
                    onClick={handleInputChange}
                  />
                </CCol>
              </CRow>
            </>
          </CForm>
        </CModalBody>
        <CModalFooter>
          <CustomButton title="Save" onClick={saveForm} isLoading={saveIsLoading} />
        </CModalFooter>
      </CModal>
    </>
  )
}
AddUpdate.propTypes = {
  visible: PropTypes.any.isRequired,
  id: PropTypes.any,
  handleClose: PropTypes.func.isRequired,
  signup: PropTypes.any,
}

export default AddUpdate
